/* Eigen meting, zie meting/LEESMIJ.md.

   Meet per bezoek welke pagina's iemand ziet, hoe lang (alleen zolang het
   tabblad zichtbaar is, en niet zolang de leeftijdscheck ervoor ligt), hoe
   ver hij scrolt en hoe ver in de animatie van de homepage, op welke knoppen
   en links hij klikt, en vanuit welke sectie iets in de mand gaat. De
   leeftijdscheck zelf telt apart: hoe lang iemand erover deed en hoe lang
   het laadscherm daarna duurde.

   Er gaat niets de deur uit zonder akkoord voor statistieken in de
   cookiebanner. Tot dat akkoord er is wacht alles in het geheugen van deze
   pagina, en er wordt ook niets op het toestel bewaard; bij weigeren gaat
   het weg. Een bezoek is een willekeurig getal in sessionStorage, geen
   cookie, en verdwijnt met het tabblad.

   Het checkout-deel staat in meting/pixel.js: in de checkout draait geen
   thema-code. */
(function () {
  'use strict';

  var script = document.currentScript;
  var EINDPUNT = script && script.getAttribute('data-eindpunt');
  if (!EINDPUNT || !window.JSON || !window.crypto || !crypto.getRandomValues) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var SOORT = script.getAttribute('data-soort') || '';
  var SLEUTEL = 'klaasje_meet';
  /* Na een half uur niets is het een nieuw bezoek. */
  var STIL_NA = 30 * 60 * 1000;
  var MAX_WACHT = 300;
  var PER_BATCH = 100;

  var html = document.documentElement;
  var paginaStart = Math.round(performance.timeOrigin || Date.now());

  function nieuwId() {
    var a = new Uint8Array(12);
    crypto.getRandomValues(a);
    var s = '';
    for (var i = 0; i < a.length; i++) s += ('0' + a[i].toString(16)).slice(-2);
    return s;
  }

  function opRust(host) {
    return host.replace(/^(www|l|lm|m|out)\./, '');
  }

  /* Productpagina's binnen een collectie (/collections/x/products/y) tellen
     als dezelfde productpagina. */
  function padVan(pathname) {
    var p = pathname.toLowerCase().replace(/\/collections\/[^/]+(\/products\/)/, '$1');
    if (p.length > 1) p = p.replace(/\/+$/, '');
    return p || '/';
  }

  function apparaat() {
    var grof = window.matchMedia && matchMedia('(pointer: coarse)').matches;
    if (!grof) return 'desktop';
    return Math.min(screen.width, screen.height) < 600 ? 'mobiel' : 'tablet';
  }

  function bronVan() {
    if (!document.referrer) return '';
    try {
      var host = new URL(document.referrer).hostname;
      if (host === location.hostname) return '';
      return opRust(host);
    } catch (e) {
      return '';
    }
  }

  function utmVan() {
    try {
      return new URLSearchParams(location.search).get('utm_source') || '';
    } catch (e) {
      return '';
    }
  }

  /* ── Het bezoek ─────────────────────────────────────────────
     Lezen mag altijd (stond het er, dan was er eerder akkoord), schrijven
     pas na akkoord. */
  var sessie = null;
  try {
    sessie = JSON.parse(sessionStorage.getItem(SLEUTEL) || 'null');
  } catch (e) {}
  var nu = Date.now();
  if (!sessie || !sessie.sid || nu - sessie.laatst > STIL_NA) {
    sessie = { sid: nieuwId(), start: nu, n: 0, bron: bronVan(), utm: utmVan() };
  }
  sessie.n += 1;
  sessie.laatst = nu;

  function bewaar() {
    try {
      sessionStorage.setItem(SLEUTEL, JSON.stringify(sessie));
    } catch (e) {}
  }

  var pv = nieuwId();
  var pad = padVan(location.pathname);
  var thema = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
  var test = navigator.webdriver ? 1 : 0;
  var app = apparaat();

  /* ── Wachtrij en versturen ─────────────────────────────── */
  var wachtrij = [];
  var toegestaan = false;
  var gestopt = false;

  function meld(t, velden) {
    if (gestopt) return;
    var e = { t: t, ts: Date.now() };
    if (velden) for (var k in velden) if (velden[k] !== undefined && velden[k] !== '') e[k] = velden[k];
    wachtrij.push(e);
    if (wachtrij.length > MAX_WACHT) wachtrij.shift();
  }

  function verstuur() {
    if (!toegestaan || gestopt) return;
    meetScroll();
    var nu = Date.now();
    var e = wachtrij.splice(0, PER_BATCH).map(function (x) {
      var y = {};
      for (var k in x) if (k !== 'ts') y[k] = x[k];
      y.ago = nu - x.ts;
      return y;
    });
    var body = JSON.stringify({
      s: sessie.sid,
      sa: nu - sessie.start,
      th: thema,
      x: test,
      app: app,
      bron: sessie.bron,
      utm: sessie.utm,
      p: { v: pv, n: sessie.n, pad: pad, soort: SOORT, ago: nu - paginaStart },
      z: { zicht: zichtNu(), scroll: scrollMax, hero: heroMax, eind: eind },
      e: e,
    });
    var ok = false;
    try {
      ok = navigator.sendBeacon(EINDPUNT, new Blob([body], { type: 'text/plain' }));
    } catch (err) {}
    if (!ok) {
      try {
        fetch(EINDPUNT, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
      } catch (err) {}
    }
    /* Meer dan één batch in de rij: meteen de volgende. */
    if (wachtrij.length) verstuur();
  }

  /* ── Tijd op de pagina ─────────────────────────────────────
     Alleen zichtbare tijd, en de klok staat stil zolang het vlak van de
     leeftijdscheck ervoor ligt: die tijd telt apart (intro_door). */
  var introOpen = html.classList.contains('klaasje-intro-open');
  var zicht = 0;
  var zichtVanaf = null;

  function klokAan() {
    if (zichtVanaf === null && !introOpen && document.visibilityState === 'visible') zichtVanaf = performance.now();
  }
  function klokUit() {
    if (zichtVanaf !== null) {
      zicht += performance.now() - zichtVanaf;
      zichtVanaf = null;
    }
  }
  function zichtNu() {
    return Math.round(zicht + (zichtVanaf !== null ? performance.now() - zichtVanaf : 0));
  }

  /* ── Scrollen en de animatie ──────────────────────────────
     Hoe ver de animatie kwam leest het script van de hero zelf af
     (progress(), 0 tot 1 over de hele sectie, uitwaaieren inbegrepen); het
     eindshot is de class is-spread-done. */
  var scrollMax = 0;
  var hero = document.querySelector('klaasje-scroll-cinematic');
  var heroMax = hero ? 0 : null;
  var eind = 0;

  function meetScroll() {
    var h = document.documentElement.scrollHeight;
    var pct = h > 0 ? Math.round(Math.min(100, ((window.scrollY + window.innerHeight) / h) * 100)) : 100;
    if (pct > scrollMax) scrollMax = pct;
    if (hero && typeof hero.progress === 'function' && !introOpen) {
      var p = Math.round(hero.progress() * 100);
      if (p > heroMax) heroMax = p;
      if (hero.classList.contains('is-spread-done')) eind = 1;
    }
  }

  var scrollGepland = false;
  window.addEventListener(
    'scroll',
    function () {
      if (scrollGepland) return;
      scrollGepland = true;
      requestAnimationFrame(function () {
        scrollGepland = false;
        meetScroll();
      });
    },
    { passive: true }
  );

  /* ── Waar iets staat ──────────────────────────────────────
     De sleutel van de sectie uit de template (klaasje_buy, klaasje_cinematic,
     ...). Heet hij main, dan de eerste klaasje-klasse erin. Het dashboard
     maakt er leesbare namen van. */
  var LAGEN = [
    ['.klaasje-intro', 'intro'],
    ['cart-drawer', 'winkelmand'],
    ['#KlaasjeMenu', 'menu'],
    ['.klaasje-social__viewer', 'social-vergroting'],
    ['.klaasje-recent__viewer', 'recent-vergroting'],
    ['#shopify-pc__banner', 'cookiebanner'],
    ['#shopify-pc__prefs', 'cookiebanner'],
  ];

  function sectieVan(el) {
    for (var i = 0; i < LAGEN.length; i++) if (el.closest(LAGEN[i][0])) return LAGEN[i][1];
    var s = el.closest('.shopify-section');
    if (!s || !s.id) return 'overig';
    var sleutel = s.id.replace(/^shopify-section-/, '').replace(/^.*__/, '');
    if (sleutel !== 'main') return sleutel;
    var k = s.querySelector('[class*="klaasje-"]');
    var m = k && /(?:^|\s)(klaasje-[a-z-]+)/.exec(k.getAttribute('class') || '');
    return m ? m[1].split('__')[0] : SOORT + '-main';
  }

  function labelVan(el) {
    var t = el.getAttribute('data-meet') || el.getAttribute('aria-label') || '';
    if (!t) t = el.innerText || el.textContent || '';
    t = t.replace(/\s+/g, ' ').trim();
    if (!t) {
      var img = el.querySelector('img[alt]');
      if (img) t = img.alt.trim();
    }
    if (!t && el.title) t = el.title;
    return (t || '(zonder tekst)').slice(0, 60).toLowerCase();
  }

  function doelVan(el) {
    if (el.tagName !== 'A' || !el.href) return '';
    try {
      var u = new URL(el.href, location.href);
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return u.protocol.replace(':', '');
      if (u.hostname === location.hostname) return (padVan(u.pathname) + u.hash).slice(0, 100);
      return opRust(u.hostname);
    } catch (e) {
      return '';
    }
  }

  /* ── Klikken ──────────────────────────────────────────────
     Elke klik op een knop, link of label. Labels van tekstvelden niet: dat
     is een klik om te typen, geen keuze. */
  var KLIKBAAR = 'a[href], button, summary, label, [role="button"], [data-meet]';
  var TYPVELD = /^(text|email|tel|number|search|date|password|url)$/;
  var kliks = [];
  /* Een klik op een label stuurt de browser nog een keer door naar het
     rondje of vinkje erin; die tweede telt niet. */
  var vorigeEl = null;
  var vorigeOp = 0;

  document.addEventListener(
    'click',
    function (event) {
      var el = event.target && event.target.closest ? event.target.closest(KLIKBAAR) : null;
      if (!el) return;
      if (el.tagName === 'LABEL' && el.control && (el.control.tagName === 'TEXTAREA' || TYPVELD.test(el.control.type || ''))) return;
      var nu = Date.now();
      if (el === vorigeEl && nu - vorigeOp < 100) return;
      vorigeEl = el;
      vorigeOp = nu;
      var sec = sectieVan(el);
      /* De cookiebanner niet: daar telt alleen wie accepteert (een weigering
         komt nooit binnen), dus het zegt niets en drukt de rest weg. */
      if (sec === 'cookiebanner') return;
      kliks.push({ sec: sec, ts: nu });
      if (kliks.length > 20) kliks.shift();
      meld('klik', { sec: sec, lab: labelVan(el), doel: doelVan(el) });
      if (el.getAttribute('name') === 'checkout') meld('afrekenen', { sec: sec });
    },
    true
  );

  /* ── In de mand ───────────────────────────────────────────
     Alle drie de plekken waar je iets in de mand legt lopen via Dawn's
     <product-form>, en die meldt een geslaagde toevoeging op
     PUB_SUB_EVENTS.cartUpdate. Uit welke sectie het formulier kwam weten we
     van de submit vlak ervoor; "via" is de laatste klik in een andere sectie
     op deze pagina (koop nu in de hero, en dan kopen in de koopsectie), de
     leeftijdscheck niet meegerekend. */
  var mandBron = null;

  document.addEventListener(
    'submit',
    function (event) {
      var f = event.target;
      var actie = f && f.getAttribute && (f.getAttribute('action') || '');
      if (actie.indexOf('/cart/add') === -1) return;
      mandBron = { sec: sectieVan(f), ts: Date.now() };
    },
    true
  );

  function viaVan(bron) {
    for (var i = kliks.length - 1; i >= 0; i--) {
      if (Date.now() - kliks[i].ts > 10 * 60 * 1000) break;
      if (kliks[i].sec !== bron && kliks[i].sec !== 'intro') return kliks[i].sec;
    }
    return '';
  }

  function luisterNaarMand() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || ev.source !== 'product-form' || !ev.cartData || ev.cartData.status) return;
      var bron = mandBron && Date.now() - mandBron.ts < 60 * 1000 ? mandBron.sec : 'onbekend';
      var via = viaVan(bron);
      var regels = ev.cartData.items || [ev.cartData];
      regels.forEach(function (r) {
        if (!r || r.handle === 'fee-rule') return;
        var naam = (r.product_title || r.title || '').toLowerCase();
        if (r.variant_title && r.variant_title !== 'Default Title') naam += ' · ' + r.variant_title.toLowerCase();
        meld('mand', { sec: bron, lab: naam.slice(0, 80), doel: via, n: r.quantity || 1 });
      });
      mandBron = null;
      verstuur();
    });
  }
  /* pubsub.js en constants.js laden eerder (zelfde defer-rij), maar voor
     de zekerheid ook na DOMContentLoaded nog een keer kijken. */
  if (typeof subscribe === 'function') luisterNaarMand();
  else document.addEventListener('DOMContentLoaded', luisterNaarMand);

  /* ── Leeftijdscheck en laadscherm ─────────────────────────
     intro_door: hoe lang na het openen van de pagina iemand door de check
     kwam. intro_klaar: hoe lang het laadscherm daarna nog duurde, tot de
     site in beeld kwam. leeftijd_nee: een datum onder de 18. */
  if (introOpen) {
    meld('intro_getoond');
    var doorOp = 0;
    document.addEventListener(
      'submit',
      function (event) {
        if (!event.target.closest || !event.target.closest('.klaasje-intro')) return;
        /* na de eigen handler van het intro, die de fout zet */
        setTimeout(function () {
          if (document.querySelector('[data-klaasje-intro-error].is-visible')) meld('leeftijd_nee');
          else if (!doorOp) {
            doorOp = Date.now();
            meld('intro_door', { n: doorOp - paginaStart });
          }
        }, 0);
      },
      true
    );
    var siteInBeeld = function () {
      if (!introOpen) return;
      introOpen = false;
      if (doorOp) meld('intro_klaar', { n: Date.now() - doorOp });
      klokAan();
      meetScroll();
    };
    document.addEventListener('klaasje:intro-leaving', siteInBeeld);
    document.addEventListener('klaasje:intro-done', siteInBeeld);
  }

  /* ── Akkoord ──────────────────────────────────────────── */
  function koppelPixel() {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('klaasje_sessie', { sid: sessie.sid });
        return true;
      }
    } catch (e) {}
    return false;
  }

  function start() {
    gestopt = false;
    if (toegestaan) return;
    toegestaan = true;
    bewaar();
    if (!koppelPixel()) window.addEventListener('load', koppelPixel, { once: true });
    verstuur();
  }

  function stop() {
    gestopt = true;
    toegestaan = false;
    wachtrij = [];
  }

  function bekijkAkkoord() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()) start();
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    if (event.detail && event.detail.analyticsAllowed) start();
    else stop();
  });

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    try {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (fout) {
        if (!fout) bekijkAkkoord();
      });
    } catch (e) {}
  } else {
    bekijkAkkoord();
  }

  /* ── Wanneer er iets weggaat ──────────────────────────────
     Bij verbergen en verlaten altijd (dat is het moment waarop de tijd op
     de pagina vaststaat), en tussendoor alleen als er iets in de rij staat. */
  klokAan();
  meetScroll();
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      klokUit();
      verstuur();
    } else {
      klokAan();
    }
  });
  window.addEventListener('pagehide', function () {
    klokUit();
    verstuur();
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) klokAan();
  });
  setInterval(function () {
    if (wachtrij.length) verstuur();
  }, 10000);
})();
